module.exports = __webpack_public_path__ + "static/cotas-abarcones-standard-bb14d65f7feabc83e4dec9b434d3fa0e.pdf";